import React, { useRef, useState } from 'react';
import { Upload, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

// Reads a device image file into a base64 data URL (frontend-only storage).
export default function ImageUpload({ value, onChange, samples = [], testid }) {
  const inputRef = useRef(null);
  const [reading, setReading] = useState(false);

  function pick() {
    inputRef.current?.click();
  }

  function handleFile(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      toast.error('Selecione um arquivo de imagem.');
      return;
    }
    if (file.size > 4 * 1024 * 1024) {
      toast.error('Imagem muito grande (máx. 4MB).');
      return;
    }
    setReading(true);
    const reader = new FileReader();
    reader.onload = () => {
      onChange(reader.result);
      setReading(false);
    };
    reader.onerror = () => {
      toast.error('Falha ao ler a imagem.');
      setReading(false);
    };
    reader.readAsDataURL(file);
  }

  return (
    <div data-testid={testid}>
      <div className="relative overflow-hidden rounded-xl border border-slate-200 bg-slate-50">
        {value ? (
          <img src={value} alt="pré-visualização" className="h-44 w-full object-cover" />
        ) : (
          <div className="flex h-44 w-full flex-col items-center justify-center text-ink-faint">
            <Upload size={26} />
            <span className="mt-1 text-sm">Nenhuma imagem</span>
          </div>
        )}
        <button
          type="button"
          onClick={pick}
          className="absolute bottom-3 left-1/2 flex -translate-x-1/2 items-center gap-2 rounded-full bg-white/95 px-4 py-2.5 font-heading text-sm font-semibold text-primary shadow-soft transition-transform duration-200 hover:-translate-y-0.5"
          style={{ transform: 'translateX(-50%)' }}
          data-testid={`${testid}-btn`}
        >
          {reading ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />}
          Enviar do dispositivo
        </button>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={handleFile}
        data-testid={`${testid}-input`}
      />
      {samples.length > 0 && (
        <>
          <p className="mt-2 text-[11px] font-medium uppercase tracking-wider text-ink-faint">
            ou use uma imagem de exemplo
          </p>
          <div className="mt-1.5 flex gap-2">
            {samples.map((src) => (
              <button
                key={src}
                type="button"
                onClick={() => onChange(src)}
                className={`h-12 flex-1 overflow-hidden rounded-lg border-2 transition-colors ${value === src ? 'border-primary' : 'border-transparent'}`}
              >
                <img src={src} alt="" className="h-full w-full object-cover" />
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
